import React, {useState, useEffect} from 'react'
import { Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import axios from 'axios'

const employees_columns = [
    { title: 'Employee ID', field: 'id' },
    { title: 'First Name', field: 'first_name' },
    { title: 'Last Name', field: 'last_name' },
]

export default function DeletedEmployeeList(props){

    var [employeesList, setEmployeesList] = useState([])
    var [employeesListVersion, setEmployeesListVersion] = useState(0)

    useEffect(() => {
        getEmployeesList(true)
    }, [employeesListVersion])

    const getEmployeesList = async deletedOnly => {
        let params = '?perPage=30&page=1&deletedOnly=true&sort_on=created_at&sort_by=desc'
        axios.get('/api/employees'+params).then(res => {
            setEmployeesList(res.data.data)
        }).catch(error => {
            console.log(error)
        })
    }

    const recoverEmployee = async id => {
        let params = { id: id}
        axios.put('/api/employees/recover_employee', params).then(res => {
            setEmployeesListVersion(employeesListVersion + 1)
        }).catch(error => {
            console.log(error)
        })
    }

    return(
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <MaterialTable
                    title='Deleted Employees'
                    columns={employees_columns}
                    data={employeesList}
                    options={{
                        headerStyle: {
                            backgroundColor: '#D8E4E4',
                            color: 'black',
                        },
                        pageSize: 10,
                    }}
                    actions={[
                        {
                          icon: 'check',
                          tooltip: 'Recover User',
                          onClick: (event, rowData) => recoverEmployee(rowData.id)
                        }
                    ]}
                />
            </Grid>
        </Grid>
    )
}